<template>
  <v-container fill-height fluid grid-list-xl>
    <v-row dense>
      <v-col>
        <material-card
          color="primary"
          :title="$t('profile')"
          full-width
        >
          <UserInfoFormDialog hideTitle/>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'UserInfo',

  components: {
    UserInfoFormDialog: () => import('@/components/settings-components/UserInfoFormDialog.vue')
  }
}
</script>
